import React from "react";
import "../../styles/OwnerExercises.css";

const OwnerAssignedExerciseItem = ({ exercise, expanded, toggleExpand }) => {
    if (!exercise || !exercise.exercise) {
        return <p className="owner-no-exercises-message">Brak danych o ćwiczeniu.</p>; // ✅ Handle missing data
    }

    const { assignedDate, completed, completionDate, exercise: exerciseDetails } = exercise;

    const difficultyMapping = {
        BASIC: "Podstawowy",
        INTERMEDIATE: "Średniozaawansowany",
        ADVANCED: "Zaawansowany"
    };

    return (
        <div
            className={`owner-exercise-card ${expanded ? "owner-exercise-open" : ""} ${completed ? "owner-exercise-completed" : ""}`}
            onClick={toggleExpand}
        >
            <div className="owner-exercise-header">
                <span className="owner-exercise-name">{exerciseDetails.name}</span>
                <span className={`owner-difficulty ${exerciseDetails.difficultyLevel.toLowerCase()}`}>
                    {difficultyMapping[exerciseDetails.difficultyLevel] || exerciseDetails.difficultyLevel}
                </span>
                {/* No action buttons for owner - only display */}
            </div>

            {expanded && (
                <div className="owner-exercise-details">
                    <p><strong>Opis:</strong><br />
                        {exerciseDetails.description}</p>
                    <p><strong>Sprzęt:</strong> {exerciseDetails.requiredEquipment || "Brak"}</p>
                    <p><strong>Data przydzielenia:</strong> {new Date(assignedDate).toLocaleDateString()}</p>
                    {completed && (
                        <p className="owner-exercise-completion-text">
                            <strong>Data ukończenia:</strong> {new Date(completionDate).toLocaleDateString()}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default OwnerAssignedExerciseItem;